import React from 'react';

import { UpdateDiscount } from './UpdateDiscount';

export const UpdateDiscountContainer = () => {
  return <UpdateDiscount isStatusEditable />;
};
